<template>
  <div>
    <!-- Dialog de confirmação para excluir amizade -->
    <v-dialog v-model="confirmModal" max-width="400" :persistent="intBreakPoint <= 1">
      <v-card>
        <v-card-title class="text-h6 pa-4"> Excluir amigo </v-card-title>
        <v-card-subtitle class="px-4 pb-2"> Confirme a ação </v-card-subtitle>
        <v-card-actions class="d-flex flex-column pa-4" style="gap: 12px;">
          <v-btn 
            color="#f44336"
            dark
            @click="excluirAmizade(removeId)" 
            block
            large
          >
            Confirmar
          </v-btn>
          <v-btn 
            @click="confirmModal = false" 
            block
            outlined
            large
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar para mensagens -->
    <v-snackbar v-model="confirm" :timeout="3000" top>
      {{ mensagemConfirm }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="confirm = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Dialog principal de Amigos -->
    <v-dialog 
      v-model="dialogVisible" 
      :max-width="intBreakPoint <= 1 ? '100%' : '1200px'"
      :fullscreen="intBreakPoint <= 1"
      scrollable
    >
      <v-card class="friends-dialog">
        <v-card-title class="d-flex justify-space-between align-center pa-4" style="border-bottom: 1px solid #e0e0e0;">
          <div class="d-flex align-center">
            <h2 style="font-size: 20px; font-weight: 600; color: #141414; margin: 0;">
              Meus Contatos
            </h2>
            <v-chip
              v-if="pendingCount > 0"
              small
              color="#F15A24"
              text-color="white"
              class="ml-3"
            >
              {{ pendingCount }}
            </v-chip>
          </div>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text class="pa-0">
          <v-row no-gutters style="height: 70vh;">
            <!-- Coluna Esquerda - Navegação -->
            <v-col cols="12" md="5" class="navigation-column">
              <div class="navigation-content">
                <!-- Busca -->
                <div class="px-4 pt-4 pb-3">
                  <div class="search-container">
                    <v-icon class="search-icon">mdi-magnify</v-icon>
                    <input
                      v-model="searchQuery"
                      type="text"
                      placeholder="Buscar pessoas ou grupos"
                      class="search-input"
                      @input="handleSearch()"
                      @keyup.enter="handleSearch(true)"
                    />
                    <v-btn
                      v-if="searchQuery"
                      icon
                      small
                      class="search-clear-btn"
                      @click="clearSearch"
                    >
                      <v-icon size="18">mdi-close</v-icon>
                    </v-btn>
                  </div>
                  <p class="search-hint mt-2">
                    <v-icon size="14" class="mr-1">mdi-information-outline</v-icon>
                    Busque por contatos existentes ou encontre novos usuários na plataforma
                  </p>
                </div>

                <!-- Lista de Navegação -->
                <div class="navigation-list">
                  <!-- Seção Pendentes -->
                  <div v-if="filteredPending.length > 0 || searchQuery === ''" class="section">
                    <div class="section-header">
                      <v-icon color="#F15A24" size="20" class="mr-2">mdi-clock-outline</v-icon>
                      <span class="section-title">Pendentes</span>
                      <v-chip v-if="filteredPending.length > 0" x-small color="#F15A24" text-color="white" class="ml-2">
                        {{ filteredPending.length }}
                      </v-chip>
                    </div>
                    <div v-if="filteredPending.length === 0 && searchQuery === ''" class="empty-state">
                      <p>Você ainda não tem convites pendentes</p>
                    </div>
                    <div
                      v-for="item in filteredPending"
                      :key="`pending-${item.id}`"
                      class="nav-item"
                      :class="{ 'selected': selectedItem && selectedItem.id === item.id && selectedItem.type === item.type }"
                      @click="selectItem(item)"
                    >
                      <div class="nav-item-content">
                        <div class="nav-avatar">
                          <v-img
                            v-if="item.type === 'friend' && item.avatar"
                            :src="`https://api.mylegis.com.br/assets/${item.avatar}`"
                            class="rounded-circle"
                            cover
                          />
                          <v-icon v-else-if="item.type === 'group'" color="#F15A24" size="32">mdi-account-group</v-icon>
                          <v-icon v-else color="#F15A24" size="32">mdi-account</v-icon>
                        </div>
                        <div class="nav-item-text">
                          <div class="nav-item-name">{{ item.name }}</div>
                          <div class="nav-item-subtitle">
                            <v-icon size="14" color="#F15A24">mdi-clock-outline</v-icon>
                            <span>convite pendente</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Seção Grupos -->
                  <div v-if="filteredGroups.length > 0 || searchQuery === ''" class="section">
                    <div class="section-header">
                      <v-icon color="#F15A24" size="20" class="mr-2">mdi-account-group</v-icon>
                      <span class="section-title">Grupos</span>
                    </div>
                    <div v-if="filteredGroups.length === 0 && searchQuery === ''" class="empty-state">
                      <p>Você ainda não faz parte de grupos</p>
                    </div>
                    <div
                      v-for="item in filteredGroups"
                      :key="`group-${item.id}`"
                      class="nav-item"
                      :class="{ 'selected': selectedItem && selectedItem.id === item.id && selectedItem.type === item.type }"
                      @click="selectItem(item)"
                    >
                      <div class="nav-item-content">
                        <div class="nav-avatar">
                          <v-icon color="#F15A24" size="32">mdi-account-group</v-icon>
                        </div>
                        <div class="nav-item-text">
                          <div class="nav-item-name">{{ item.name }}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Seção Amigos -->
                  <div v-if="filteredFriends.length > 0 || searchQuery === ''" class="section">
                    <div class="section-header">
                      <v-icon color="#F15A24" size="20" class="mr-2">mdi-account</v-icon>
                      <span class="section-title">Amigos</span>
                    </div>
                    <div v-if="filteredFriends.length === 0 && searchQuery === ''" class="empty-state">
                      <p>Você ainda não tem amigos adicionados</p>
                    </div>
                    <div
                      v-for="item in filteredFriends"
                      :key="`friend-${item.id}`"
                      class="nav-item"
                      :class="{ 'selected': selectedItem && selectedItem.id === item.id && selectedItem.type === item.type }"
                      @click="selectItem(item)"
                    >
                      <div class="nav-item-content">
                        <div class="nav-avatar">
                          <v-img
                            v-if="item.avatar"
                            :src="`https://api.mylegis.com.br/assets/${item.avatar}`"
                            class="rounded-circle"
                            cover
                          />
                          <v-icon v-else color="#F15A24" size="32">mdi-account</v-icon>
                        </div>
                        <div class="nav-item-text">
                          <div class="nav-item-name">{{ item.name }}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Seção Novos Usuários (quando busca na plataforma) -->
                  <div v-if="searchQuery && (platformUsers.length > 0 || searchingPlatform)" class="section">
                    <div class="section-header">
                      <v-icon color="#F15A24" size="20" class="mr-2">mdi-account-plus</v-icon>
                      <span class="section-title">Usuários na Plataforma</span>
                    </div>
                    <div
                      v-for="user in platformUsers"
                      :key="`platform-${user.id}`"
                      class="nav-item platform-user"
                      @click="selectPlatformUser(user)"
                    >
                      <div class="nav-item-content">
                        <div class="nav-avatar">
                          <v-img
                            v-if="user.avatar"
                            :src="`https://api.mylegis.com.br/assets/${user.avatar}`"
                            class="rounded-circle"
                            cover
                          />
                          <v-icon v-else color="#F15A24" size="32">mdi-account</v-icon>
                        </div>
                        <div class="nav-item-text">
                          <div class="nav-item-name">
                            {{ user.first_name }} {{ user.last_name || '' }}
                          </div>
                          <div class="nav-item-subtitle" style="color: #666;">
                            {{ user.email }}
                          </div>
                        </div>
                        <div class="nav-item-action">
                          <v-btn
                            v-if="!user.adicionado"
                            small
                            color="#F15A24"
                            class="white--text"
                            @click.stop="adicionarAmigo(user)"
                            :loading="user.adding"
                          >
                            Adicionar
                          </v-btn>
                          <v-chip v-else small color="success" text-color="white">
                            Adicionado
                          </v-chip>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Mensagem quando busca não encontra nada -->
                  <div v-if="searchQuery && filteredPending.length === 0 && filteredGroups.length === 0 && filteredFriends.length === 0 && platformUsers.length === 0 && !searchingPlatform" class="empty-state">
                    <p>Nenhum resultado encontrado</p>
                  </div>
                  <div v-if="searchQuery && searchingPlatform" class="empty-state">
                    <v-progress-circular indeterminate color="#F15A24" size="24"></v-progress-circular>
                    <p class="mt-2">Buscando na plataforma...</p>
                  </div>
                </div>
              </div>
            </v-col>

            <!-- Coluna Direita - Detalhes -->
            <v-col cols="12" md="7" class="details-column">
              <div class="details-content">
                <div v-if="!selectedItem" class="empty-details">
                  <v-icon size="64" color="#ccc" class="mb-4">mdi-account-multiple</v-icon>
                  <p style="color: #999; font-size: 16px;">Selecione um contato ou grupo para ver os detalhes</p>
                </div>
                
                <div v-else class="details-panel">
                  <!-- Avatar Grande -->
                  <div class="details-header">
                    <div class="details-avatar">
                      <v-img
                        v-if="selectedItem.type === 'friend' && selectedItem.avatar"
                        :src="`https://api.mylegis.com.br/assets/${selectedItem.avatar}`"
                        class="rounded-circle"
                        cover
                      />
                      <v-icon v-else-if="selectedItem.type === 'group'" color="#F15A24" size="80">mdi-account-group</v-icon>
                      <v-icon v-else color="#F15A24" size="80">mdi-account</v-icon>
                    </div>
                    <div class="details-info">
                      <h3 class="details-name">{{ selectedItem.name }}</h3>
                      <div class="details-type">
                        <v-chip small :color="selectedItem.type === 'group' ? '#F15A24' : '#4CAF50'" text-color="white">
                          {{ selectedItem.type === 'group' ? 'Grupo' : 'Usuário' }}
                        </v-chip>
                      </div>
                      <div v-if="selectedItem.status" class="details-status">
                        <v-icon size="16" :color="getStatusColor(selectedItem.status)">{{ getStatusIcon(selectedItem.status) }}</v-icon>
                        <span>{{ getStatusText(selectedItem.status) }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Ações Contextuais -->
                  <div class="details-actions">
                    <template v-if="selectedItem.status === 'pendente'">
                      <v-btn
                        color="#4CAF50"
                        class="white--text mr-3"
                        @click="handleAccept"
                      >
                        <v-icon left>mdi-check</v-icon>
                        Aceitar
                      </v-btn>
                      <v-btn
                        color="#f44336"
                        class="white--text"
                        @click="handleReject"
                      >
                        <v-icon left>mdi-close</v-icon>
                        Recusar
                      </v-btn>
                    </template>
                    <template v-else-if="selectedItem.status === 'novo'">
                      <v-btn
                        color="#F15A24"
                        class="white--text"
                        @click="adicionarAmigo(selectedItem.originalUser)"
                        :loading="selectedItem.originalUser && selectedItem.originalUser.adding"
                        :disabled="selectedItem.originalUser && selectedItem.originalUser.adicionado"
                      >
                        <v-icon left>mdi-account-plus</v-icon>
                        {{ selectedItem.originalUser && selectedItem.originalUser.adicionado ? 'Adicionado' : 'Adicionar Amigo' }}
                      </v-btn>
                    </template>
                    <template v-else-if="selectedItem.status === 'enviado'">
                      <v-btn
                        color="#f44336"
                        class="white--text"
                        @click="cancelarConvite"
                      >
                        <v-icon left>mdi-close-circle</v-icon>
                        Cancelar Convite
                      </v-btn>
                    </template>
                    <template v-else-if="selectedItem.type === 'group'">
                      <v-btn
                        color="#F15A24"
                        class="white--text mr-3"
                        @click="viewGroup"
                      >
                        <v-icon left>mdi-eye</v-icon>
                        Ver Grupo
                      </v-btn>
                    </template>
                    <template v-else-if="selectedItem.type === 'friend' && selectedItem.status === 'aceito'">
                      <v-btn
                        color="#F15A24"
                        class="white--text mr-3"
                        @click="viewProfile"
                      >
                        <v-icon left>mdi-account</v-icon>
                        Ver Perfil
                      </v-btn>
                      <v-btn
                        color="#f44336"
                        class="white--text"
                        @click="handleRemove"
                      >
                        <v-icon left>mdi-account-remove</v-icon>
                        Remover
                      </v-btn>
                    </template>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'DialogAmigos',
  data() {
    return {
      dialogVisible: false,
      confirmModal: false,
      confirm: false,
      mensagemConfirm: "",
      friends: [],
      friendsInvited: [],
      friendsWaitingAccept: [],
      groupsWaitingAccept: [],
      selectedItem: null,
      searchQuery: '',
      platformUsers: [],
      searchingPlatform: false,
      searchTimeout: null,
      removeId: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    groups() {
      return this.$store.state.user ? this.$store.state.user.grupos : [];
    },
    intBreakPoint() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 0;
        case "sm":
          return 1;
        case "md":
          return 2;
        case "lg":
          return 3;
        case "xl":
          return 4;
        default:
          return 0;
      }
    },
    pendingCount() {
      return this.friendsWaitingAccept.length + this.groupsWaitingAccept.length;
    },
    allPendingItems() {
      const items = [];
      
      // Amigos pendentes
      this.friendsWaitingAccept.forEach(friend => {
        if (friend.id_usuario) {
          items.push({
            id: friend.id_usuario.id,
            originalId: friend.id,
            name: friend.id_usuario.first_name + (friend.id_usuario.last_name ? ' ' + friend.id_usuario.last_name : ''),
            avatar: friend.id_usuario.avatar,
            type: 'friend',
            status: 'pendente'
          });
        }
      });
      
      // Grupos pendentes
      this.groupsWaitingAccept.forEach(group => {
        if (group.id_grupo) {
          items.push({
            id: group.id_grupo.id,
            originalId: group.id,
            name: group.id_grupo.nome_grupo,
            type: 'group',
            status: 'pendente'
          });
        }
      });
      
      return items;
    },
    allGroupItems() {
      const items = [];
      if (this.groups && Array.isArray(this.groups)) {
        this.groups.forEach(group => {
          if (group.grupos_id) {
            items.push({
              id: group.grupos_id.id,
              name: group.grupos_id.nome_grupo,
              type: 'group',
              status: 'aceito'
            });
          }
        });
      }
      return items;
    },
    allFriendItems() {
      const items = [];
      
      // Amigos aceitos
      this.friends.forEach(friend => {
        if (friend.id_amigo) {
          items.push({
            id: friend.id_amigo.id,
            originalId: friend.id,
            name: friend.id_amigo.first_name + (friend.id_amigo.last_name ? ' ' + friend.id_amigo.last_name : ''),
            avatar: friend.id_amigo.avatar,
            type: 'friend',
            status: 'aceito'
          });
        }
      });
      
      // Convites enviados
      this.friendsInvited.forEach(friend => {
        if (friend.id_adicionado) {
          items.push({
            id: friend.id_adicionado.id,
            originalId: friend.id,
            name: friend.id_adicionado.first_name + (friend.id_adicionado.last_name ? ' ' + friend.id_adicionado.last_name : ''),
            avatar: friend.id_adicionado.avatar,
            type: 'friend',
            status: 'enviado'
          });
        }
      });
      
      return items;
    },
    filteredPending() {
      if (!this.searchQuery) return this.allPendingItems;
      const query = this.searchQuery.toLowerCase();
      return this.allPendingItems.filter(item => 
        item.name.toLowerCase().includes(query)
      );
    },
    filteredGroups() {
      if (!this.searchQuery) return this.allGroupItems;
      const query = this.searchQuery.toLowerCase();
      return this.allGroupItems.filter(item => 
        item.name.toLowerCase().includes(query)
      );
    },
    filteredFriends() {
      if (!this.searchQuery) return this.allFriendItems;
      const query = this.searchQuery.toLowerCase();
      return this.allFriendItems.filter(item => 
        item.name.toLowerCase().includes(query)
      );
    },
  },
  watch: {
    dialogVisible(newVal) {
      if (!newVal) {
        this.selectedItem = null;
        this.searchQuery = '';
        this.platformUsers = [];
        this.searchingPlatform = false;
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
          this.searchTimeout = null;
        }
        // Notificar que o diálogo foi fechado
        this.$root.$emit('dialog-amigos-fechado');
      } else {
        // Quando o diálogo é aberto, carregar dados
        if (this.user && this.user.id) {
          this.loadFriends();
          this.loadFriendsInvited();
          this.loadFriendsWaitingAccept();
          this.loadGroupsWaitingAccept();
        }
        // Notificar que as notificações foram vistas
        this.$root.$emit('notificacoes-vistas');
      }
    },
  },
  mounted() {
    // Listener para abrir o diálogo quando solicitado
    this.$root.$on('abrir-dialog-amigos', () => {
      this.dialogVisible = true;
    });
  },
  beforeDestroy() {
    this.$root.$off('abrir-dialog-amigos');
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false;
    },
    async loadFriends() {
      if (!this.user || !this.user.id) return;
      try {
        const {
          data: {
            data: { amigos },
          },
        } = await this.$http.get(
          `users/${this.user.id}?fields=amigos.id_amigo.id,amigos.id_amigo.avatar,amigos.id_amigo.first_name,amigos.id_amigo.last_name,amigos.id`
        );
        this.friends = amigos || [];
      } catch (error) {
        window.console.error('Erro ao carregar amigos:', error);
      }
    },
    async loadFriendsInvited() {
      if (!this.user || !this.user.id) return;
      try {
        const dt = await this.$http.get(
          `items/add_amigo/?fields=id,id_adicionado.id,id_adicionado.first_name,id_adicionado.avatar,id_adicionado.last_name&filter[status][_eq]=pendente&filter[id_usuario][_eq]=${this.user.id}`
        );
        this.friendsInvited = dt.data.data || [];
      } catch (error) {
        window.console.error('Erro ao carregar convites enviados:', error);
      }
    },
    async loadFriendsWaitingAccept() {
      if (!this.user || !this.user.id) return;
      try {
        const dt = await this.$http.get(
          `items/add_amigo/?fields=id,id_usuario.id,id_usuario.first_name,id_usuario.avatar,id_usuario.last_name&filter[status][_eq]=pendente&filter[id_adicionado][_eq]=${this.user.id}`
        );
        this.friendsWaitingAccept = dt.data.data || [];
      } catch (error) {
        window.console.error('Erro ao carregar convites pendentes:', error);
      }
    },
    async loadGroupsWaitingAccept() {
      if (!this.user || !this.user.id) return;
      try {
        const dt = await this.$http.get(
          `items/add_grupos/?fields=id,id_grupo.id,id_grupo.nome_grupo&filter[status][_eq]=pendente&filter[id_usuario][_eq]=${this.user.id}`
        );
        this.groupsWaitingAccept = dt.data.data || [];
      } catch (error) {
        window.console.error('Erro ao carregar grupos pendentes:', error);
      }
    },
    async aceitarAmizade(id) {
      try {
        const dt = await this.$http.patch(`items/add_amigo/${id}`, {
          status: `aceito`,
        });
        if (dt.data.data.id === id) {
          this.mensagemConfirm = "Solicitação aceita!";
          this.confirm = true;
          this.selectedItem = null;
          await this.loadFriendsWaitingAccept();
          await this.loadFriends();
          // Notificar o Painel para atualizar notificações
          this.$root.$emit('atualizar-notificacoes');
        }
      } catch (error) {
        window.console.error('Erro ao aceitar amizade:', error);
        this.mensagemConfirm = "Erro ao aceitar solicitação. Tente novamente.";
        this.confirm = true;
      }
    },
    async excluirAmizade(id) {
      try {
        // Buscar o registro para obter informações do amigo
        const { data: registroData } = await this.$http.get(
          `items/meus_amigos/${id}?fields=id,id_usuario,id_usuario.id,id_amigo,id_amigo.id`
        );
        
        if (!registroData.data) {
          window.console.error('Registro de amizade não encontrado');
          this.confirmModal = false;
          return;
        }
        
        const registro = registroData.data;
        // Lidar com estrutura de dados (pode ser objeto ou ID direto)
        const meuId = (registro.id_usuario && registro.id_usuario.id) ? registro.id_usuario.id : registro.id_usuario;
        const amigoId = (registro.id_amigo && registro.id_amigo.id) ? registro.id_amigo.id : registro.id_amigo;
        
        if (!meuId || !amigoId) {
          window.console.error('Não foi possível identificar os IDs do usuário e amigo');
          this.confirmModal = false;
          return;
        }
        
        // Remover o registro atual
        await this.$http.delete(`items/meus_amigos/${id}`);
        
        // Buscar e remover o registro correspondente do outro lado
        try {
          const { data: registroOpostoData } = await this.$http.get(
            `items/meus_amigos?filter[id_usuario][_eq]=${amigoId}&filter[id_amigo][_eq]=${meuId}&fields=id&limit=1`
          );
          
          if (registroOpostoData.data && registroOpostoData.data.length > 0) {
            const registroOpostoId = registroOpostoData.data[0].id;
            await this.$http.delete(`items/meus_amigos/${registroOpostoId}`);
          }
        } catch (err) {
          window.console.warn('Aviso: Não foi possível encontrar o registro correspondente do outro lado:', err);
        }
        
        this.confirmModal = false;
        this.mensagemConfirm = "Amizade removida com sucesso!";
        this.confirm = true;
        await this.loadFriends();
        
        // Atualizar o item selecionado se necessário
        if (this.selectedItem && this.selectedItem.originalId === id) {
          this.selectedItem = null;
        }
      } catch (error) {
        window.console.error('Erro ao remover amizade:', error);
        this.mensagemConfirm = "Erro ao remover amizade. Tente novamente.";
        this.confirm = true;
        this.confirmModal = false;
      }
    },
    async recusarAmizade(id) {
      try {
        const dt = await this.$http.patch(`items/add_amigo/${id}`, {
          status: `recusado`,
        });
        if (dt.data.data.id === id) {
          this.mensagemConfirm = "Solicitação recusada!";
          this.confirm = true;
          this.selectedItem = null;
          await this.loadFriendsWaitingAccept();
          // Notificar o Painel para atualizar notificações
          this.$root.$emit('atualizar-notificacoes');
        }
      } catch (error) {
        window.console.error('Erro ao recusar amizade:', error);
        this.mensagemConfirm = "Erro ao recusar solicitação. Tente novamente.";
        this.confirm = true;
      }
    },
    async cancelarConvite() {
      if (!this.selectedItem || this.selectedItem.status !== 'enviado') return;
      
      const conviteId = this.selectedItem.originalId;
      if (!conviteId) {
        this.mensagemConfirm = "Erro: ID do convite não encontrado.";
        this.confirm = true;
        return;
      }
      
      try {
        // Deletar o convite da tabela add_amigo
        await this.$http.delete(`items/add_amigo/${conviteId}`);
        
        this.mensagemConfirm = "Convite cancelado com sucesso!";
        this.confirm = true;
        
        // Limpar seleção
        this.selectedItem = null;
        
        // Recarregar lista de convites enviados
        await this.loadFriendsInvited();
        
        // Atualizar lista de amigos para remover o item cancelado
        await this.loadFriends();
      } catch (error) {
        window.console.error('Erro ao cancelar convite:', error);
        this.mensagemConfirm = "Erro ao cancelar convite. Tente novamente.";
        this.confirm = true;
      }
    },
    async aceitarGrupo(id) {
      try {
        const dt = await this.$http.patch(`items/add_grupos/${id}`, {
          status: `aceito`,
        });
        if (dt.data.data.id === id) {
          this.mensagemConfirm = "Solicitação aceita!";
          this.confirm = true;
          this.selectedItem = null;
          await this.loadGroupsWaitingAccept();
          await this.$store.dispatch("getInfo");
        }
      } catch (error) {
        window.console.error('Erro ao aceitar grupo:', error);
        this.mensagemConfirm = "Erro ao aceitar solicitação. Tente novamente.";
        this.confirm = true;
      }
    },
    async recusarGrupo(id) {
      try {
        const dt = await this.$http.patch(`items/add_grupos/${id}`, {
          status: `recusado`,
        });
        if (dt.data.data.id === id) {
          this.mensagemConfirm = "Solicitação recusada!";
          this.confirm = true;
          this.selectedItem = null;
          await this.loadGroupsWaitingAccept();
          // Notificar o Painel para atualizar notificações
          this.$root.$emit('atualizar-notificacoes');
        }
      } catch (error) {
        window.console.error('Erro ao recusar grupo:', error);
        this.mensagemConfirm = "Erro ao recusar solicitação. Tente novamente.";
        this.confirm = true;
      }
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    selectPlatformUser(user) {
      this.selectedItem = {
        id: user.id,
        name: `${user.first_name} ${user.last_name || ''}`.trim(),
        avatar: user.avatar,
        type: 'friend',
        status: user.adicionado ? 'enviado' : 'novo',
        email: user.email,
        originalUser: user
      };
    },
    async handleSearch(immediate = false) {
      // Limpar resultados da plataforma quando busca muda
      this.platformUsers = [];
      this.searchingPlatform = false;
      
      // Se a busca está vazia, não buscar na plataforma
      if (!this.searchQuery || this.searchQuery.trim().length < 2) {
        return;
      }
      
      // Se for busca imediata (Enter), buscar sem delay
      if (immediate) {
        await this.$nextTick();
        await this.searchPlatformUsers();
        return;
      }
      
      // Aguardar um pouco para evitar muitas requisições enquanto o usuário digita
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(async () => {
        await this.$nextTick();
        await this.searchPlatformUsers();
      }, 500);
    },
    clearSearch() {
      this.searchQuery = '';
      this.platformUsers = [];
      this.searchingPlatform = false;
      this.selectedItem = null;
    },
    async searchPlatformUsers() {
      if (!this.searchQuery || this.searchQuery.trim().length < 2) {
        this.platformUsers = [];
        this.searchingPlatform = false;
        return;
      }
      
      this.searchingPlatform = true;
      try {
        const searchTerm = this.searchQuery.trim();
        
        // Buscar por nome usando o store
        await this.$store.dispatch("searchUsuarios", searchTerm);
        let usuariosPorNome = (this.$store.state.users || []).filter(user => 
          user.id !== this.user.id
        );
        
        // Também buscar por email diretamente
        let usuariosPorEmail = [];
        try {
          const { data } = await this.$http.get(
            `users?filter[email][_contains]=${searchTerm}&fields=id,first_name,last_name,email,avatar&limit=10`
          );
          usuariosPorEmail = (data.data || []).filter(user => 
            user.id !== this.user.id
          );
        } catch (err) {
          window.console.warn('Erro ao buscar por email:', err);
        }
        
        // Combinar resultados e remover duplicatas
        const todosUsuarios = [...usuariosPorNome, ...usuariosPorEmail];
        const usuariosUnicos = todosUsuarios.filter((user, index, self) =>
          index === self.findIndex(u => u.id === user.id)
        );
        
        // Verificar quais já são amigos ou têm convite pendente
        const friendIds = new Set([
          ...this.friends.map(f => f.id_amigo && f.id_amigo.id).filter(Boolean),
          ...this.friendsInvited.map(f => f.id_adicionado && f.id_adicionado.id).filter(Boolean),
          ...this.friendsWaitingAccept.map(f => f.id_usuario && f.id_usuario.id).filter(Boolean)
        ]);
        
        // Filtrar usuários que já estão na lista e que correspondem à busca
        const usuariosFiltrados = usuariosUnicos.filter(user => {
          // Não mostrar se já é amigo
          if (friendIds.has(user.id)) {
            return false;
          }
          
          // Verificar se o nome corresponde à busca (case insensitive)
          const nomeCompleto = `${user.first_name || ''} ${user.last_name || ''}`.toLowerCase().trim();
          const email = (user.email || '').toLowerCase();
          const buscaLower = searchTerm.toLowerCase();
          
          return nomeCompleto.includes(buscaLower) || email.includes(buscaLower);
        });
        
        this.platformUsers = usuariosFiltrados.map(user => ({
          ...user,
          adicionado: friendIds.has(user.id),
          adding: false
        }));
      } catch (error) {
        window.console.error("Erro ao buscar usuários na plataforma:", error);
        this.platformUsers = [];
      } finally {
        this.searchingPlatform = false;
      }
    },
    handleAccept() {
      if (!this.selectedItem) return;
      if (this.selectedItem.type === 'friend') {
        this.aceitarAmizade(this.selectedItem.originalId);
      } else if (this.selectedItem.type === 'group') {
        this.aceitarGrupo(this.selectedItem.originalId);
      }
      this.selectedItem = null;
    },
    handleReject() {
      if (!this.selectedItem) return;
      if (this.selectedItem.type === 'friend') {
        this.recusarAmizade(this.selectedItem.originalId);
      } else if (this.selectedItem.type === 'group') {
        this.recusarGrupo(this.selectedItem.originalId);
      }
      this.selectedItem = null;
    },
    handleRemove() {
      if (!this.selectedItem) return;
      this.removeId = this.selectedItem.originalId;
      this.confirmModal = true;
    },
    viewGroup() {
      if (!this.selectedItem || this.selectedItem.type !== 'group') return;
      this.$router.push(`/painel/grupo/${this.selectedItem.id}`);
      this.dialogVisible = false;
    },
    viewProfile() {
      if (!this.selectedItem || this.selectedItem.type !== 'friend') return;
      const name = this.selectedItem.name.split(' ')[0];
      this.$router.push(`/painel/u/${this.selectedItem.id}/${this.sanitizeTitle(name)}`);
      this.dialogVisible = false;
    },
    getStatusColor(status) {
      switch(status) {
        case 'pendente': return '#F15A24';
        case 'aceito': return '#4CAF50';
        case 'recusado': return '#999';
        case 'enviado': return '#FF9800';
        default: return '#999';
      }
    },
    getStatusIcon(status) {
      switch(status) {
        case 'pendente': return 'mdi-clock-outline';
        case 'aceito': return 'mdi-check-circle';
        case 'recusado': return 'mdi-close-circle';
        case 'enviado': return 'mdi-send';
        default: return 'mdi-information';
      }
    },
    getStatusText(status) {
      switch(status) {
        case 'pendente': return 'Convite pendente';
        case 'aceito': return 'Aceito';
        case 'recusado': return 'Recusado';
        case 'enviado': return 'Convite enviado';
        default: return status;
      }
    },
    async adicionarAmigo(user) {
      if (user.adding || user.adicionado) return;
      
      user.adding = true;
      try {
        const response = await this.$http.post("items/add_amigo", {
          id_adicionado: user.id,
          id_usuario: this.user.id,
          status: 'pendente',
        });
        if (response.data.data.id) {
          user.adicionado = true;
          this.mensagemConfirm = "Requisição de amizade realizada com sucesso!";
          this.confirm = true;
          await this.loadFriendsInvited();
          
          // Atualizar o item selecionado se for o mesmo usuário
          if (this.selectedItem && this.selectedItem.originalUser && this.selectedItem.originalUser.id === user.id) {
            this.selectedItem.status = 'enviado';
          }
        }
      } catch (error) {
        window.console.error("Erro ao adicionar amigo:", error);
        this.mensagemConfirm = "Erro ao enviar solicitação. Tente novamente.";
        this.confirm = true;
      } finally {
        user.adding = false;
      }
    },
    sanitizeTitle(title) {
      var slug = "";
      var titleLower = title.toLowerCase();
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      slug = slug.replace(/đ/gi, "d");
      slug = slug.replace(/\s*$/g, "");
      slug = slug.replace(/\s+/g, "-");
      return slug;
    },
  },
};
</script>

<style scoped>
/* Estilos para Dialog Meus Amigos */
.friends-dialog {
  overflow: hidden;
}

.navigation-column {
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.navigation-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.search-container {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #999;
  z-index: 1;
}

.search-input {
  width: 100%;
  padding: 12px 12px 12px 40px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
}

.search-input:focus {
  border-color: #F15A24;
}

.search-clear-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
}

.search-hint {
  font-size: 12px;
  color: #666;
  margin: 0;
  display: flex;
  align-items: center;
}

.platform-user {
  border-left: 3px solid #FF9800;
}

.nav-item-action {
  margin-left: auto;
  padding-left: 12px;
}

.navigation-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}

.section {
  margin-bottom: 16px;
}

.section-header {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  font-weight: 600;
  font-size: 14px;
  color: #141414;
  background-color: #f5f5f5;
}

.section-title {
  flex: 1;
}

.nav-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  border-left: 3px solid transparent;
}

.nav-item:hover {
  background-color: #f9f9f9;
}

.nav-item.selected {
  background-color: #fff5f0;
  border-left-color: #F15A24;
}

.nav-item-content {
  display: flex;
  align-items: center;
}

.nav-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.nav-item-text {
  flex: 1;
  min-width: 0;
}

.nav-item-name {
  font-size: 14px;
  font-weight: 600;
  color: #141414;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nav-item-subtitle {
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 4px;
}

.empty-state {
  padding: 24px 16px;
  text-align: center;
  color: #999;
  font-size: 14px;
}

.details-column {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fafafa;
}

.details-content {
  flex: 1;
  padding: 24px;
  overflow-y: auto;
}

.empty-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
}

.details-panel {
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.details-header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e0e0e0;
}

.details-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  flex-shrink: 0;
  background-color: #f5f5f5;
}

.details-info {
  flex: 1;
}

.details-name {
  font-size: 24px;
  font-weight: 600;
  color: #141414;
  margin-bottom: 8px;
}

.details-type {
  margin-bottom: 8px;
}

.details-status {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #666;
}

.details-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

/* Responsividade Mobile */
@media (max-width: 960px) {
  .navigation-column {
    border-right: none;
    border-bottom: 1px solid #e0e0e0;
    max-height: 40vh;
  }
  
  .details-column {
    max-height: 60vh;
  }
  
  .friends-dialog .v-card-text .v-row {
    flex-direction: column;
  }
}
</style>
